import {
    UilReceipt, UilHome
} from "@iconscout/vue-unicons";

import i18n from "@/modules/i18n";
// import store from "@/store";

/* Voir /store/index.js:hasPerms pour les explications de permissions */
export default [
    // Inactif tant que ça n'est pas fonctionnel
    {
        path: "/",
        name: "home",
        title: i18n.t("menu.accueil"),
        icon: UilHome,
        component: () => import(/* webpackChunkName: "home" */ "@/views/Home.vue"),
        submenu: [{}, ]
    },
    {
        path: "/commande",
        name: "commande_suivi",
        title: i18n.t("menu.suivi-commande"),
        icon: UilReceipt,
        component: () => import("@/views/CommandeListe.vue"),
        submenu: [
            {
                path: "/suivi",
                name: "individuel",
                title: i18n.t("menu.details"),
                icon: UilReceipt,
                goBackBtn: true,
                props: true,
                component: () => import("@/views/Commande.vue"),
            },
        ],
    },
];